<template>
  <div class="sports_result" v-if="itemDetail" style="background:#1A9DFE">
    <div class="go-back">
      <!-- <van-button @click="goBack" size="small" :color="buttonColor"><van-icon name="arrow-left" /> 返回</van-button> -->
    </div>
    <div class="header">
      <div class="avatar">
        <van-image v-if="itemDetail.userInfo.avatarurl" :src="itemDetail.userInfo.avatarurl"></van-image>
        <div v-else class="van-image" :style="{background:filername(itemDetail.userInfo.nickname)}">{{itemDetail.userInfo.nickname.substr(0,1)}}</div>
      </div>
      <div class="info">
        <div class="nickname">
          {{ itemDetail.name ? itemDetail.name : itemDetail.userInfo.nickname }}
        </div>
        <div class="rank">
          <span>排名：第 {{ itemDetail.rank || '-' }} 名</span>
          <span>票数：{{ itemDetail.score }} 票</span>
        </div>
      </div>
    </div>

    <div class="body">
      <div class="header">
        <div class="title" style="background:#1A9DFE">选手信息</div>
      </div>

      <div class="body">
        <mVideo :videoUrl="itemDetail.mediaurl" height="3.5rem" :mediaType="itemDetail.sportsItemSub.media_type"></mVideo>
        <div class="desc">
          我正在参加“{{ itemDetail.sportsItemSub.title }}”。动动手指，请帮我投一票吧！
          <p style="font-weight: bold;"></p>
          <!-- <p v-if="+itemDetail.myinfo.state">
            系统得分:{{ itemDetail.myinfo.score }}
          </p> -->
        </div>
        <div class="btn-area">
          <van-button round plain color="#1A9DFE" @click="show = true">分 享</van-button>
          <van-button round plain @click="vote" color="#1A9DFE">投 票</van-button>
        </div>
      </div>
    </div>
    <Footbar>
      <Cell slot="footbar">
        <Button
          v-if="itemDetail.today_state !== 1"
          round
          type="primary"
          block
          :color="buttonColor"
          :to="{ name: 'joinSports', params: this.$route.params }"
          >立即参与</Button
        >
        <Button v-else round type="primary" block :color="buttonColor" :to="{ name: 'sportsResult', params: this.$route.params }"
          >参赛详情</Button
        >
      </Cell>
    </Footbar>
    <van-overlay z-index="1000" :show="show" @click="show = false">
      <div class="wrapper">
        <img style="width:100%" src="../../../assets/img/common/share.png" />
      </div>
    </van-overlay>
  </div>
  <Empty v-else description="数据加载中" />
</template>

<script>
import mVideo from '@/components/mVideo/index'
import { mapGetters } from 'vuex'
import Footbar from '@/components/footbar/index'
import util from 'libs/utils';
import { Empty, Panel, Cell, Button, CellGroup, Image, Popup, Overlay,ImagePreview } from 'vant'

export default {
  computed: {
    buttonColor() {
        return `#0598D6`;
    }
  },
  components: {
    Footbar,
    Empty,
    Panel,
    Cell,
    Button,
    CellGroup,
    VanImage: Image,
    VanOverlay: Overlay,
    mVideo,
    Popup,
    ImagePreview
  },
  data() {
    return {
      show: false,
      detail: '',
      itemDetail: '',
      joinList: [],
      item_sub_id: '',
      matchid: '',
      certShow: false,
    }
  },
  methods: {
    filername(name){
      let val = util.hc(name,6)
      console.log(val)
      switch(val*1){
        case 0:
          return '#B9C5D1';
        case 1:
          return '#D2C1B9';
        case 2:
          return '#BAB3C6';
        case 3:
          return '#D3BFC8';
        case 4:
          return '#D0CAB2';
        case 5:
          return '#B6C3B2';
      }
    },
    goBack() {
      this.$router.push({
        name: 'sportsDetail',
        params: this.$route.params,
      })
    },
    openImg(url) {
      // ...
      // ImagePreview([url]);
      wx.previewImage({
        current: '', // 当前显示图片的http链接
        urls: [url], // 需要预览的图片http链接列表
      })
    },
    vote() {
      this.$api.mwap
        .vote({
          vcid: this.$route.query.id,
        })
        .then((r) => {
          this.init()
          this.$toast.success(r.message)
        })
    },
    init: function() {
      this.$toast.loading({
        duration: 0,
      })
      let params = { cpgid: this.item_sub_id }
      this.$api.mwap.getVoteDetail({vcid:this.$route.query.id})
        .then((res) => {
          // this.joinList = res[1]['list'];
          if (res.data.registerinfos) {
            try {
              res.data.registerinfos = JSON.parse(res.data.registerinfos);
            } catch (e) {
              console.log(e)
            }
          }
          this.itemDetail = res.data

          this.$toast.clear()
        })
        .then(() => {
          const shareConf = {
            title: ` 我正在参加“${this.itemDetail.sportsItemSub.title}”。动动手指，请帮我投一票吧！`,
            path: '/pages/webview/index?src=' + encodeURIComponent(window.location.href),
          }

          wx.miniProgram.postMessage({ data: JSON.stringify(shareConf) })
        })
    },
  },
  mounted() {
    this.item_sub_id = this.$route.params.item_sub_id
    this.matchid = this.$route.params.matchid
    this.init()
  },
}
</script>

<style lang="less" scoped>
.sports_result {
  width: 100vw;
  //height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  .go-back {
    width: 100%;
    padding: 0.3rem;
    font-size: 0;
    box-sizing: border-box;
  }
  .wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    img {
      width: 100%;
      position: absolute;
      top: 0rem;
    }
  }
  > .header {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: #fff;
    width: 6.08rem;
    margin: 0.12rem auto 0.24rem;
    border-radius: 0.22rem;
    padding: 0.24rem 0.4rem;
    > .avatar {
      width: 1.04rem;
      height: 1.04rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 0.48rem;

      > .van-image {
        overflow: hidden;
        width: 1.04rem;
        height: 1.04rem;
        border-radius: 50%;
        line-height: 1.04rem;
        font-size: .4rem;
        text-align: center;
        color: #fff;
      }
    }
    > .info {
      > .nickname {
        font-size: 0.28rem;
        line-height: 1.5;
        color: #666;
      }
      .rank {
        margin-top: 0.2rem;
        font-size: 0.24rem;
        color: #666;
        span:first-of-type {
          margin-right: 0.5rem;
        }
      }
    }
  }
  > .body {
    box-shadow: 0px 0.04rem 0.34rem #fa604935;
    width: 6.08rem;
    border-radius: 0.22rem;
    overflow: hidden;
    background: #ffffff;
    > .header {
      width: 100%;
      height: 1.23rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .title {
        font-size: 0.28rem;
        color: #fff;
        background: #4eb4ff;
        width: 2.26rem;
        height: 0.7rem;
        line-height: 0.7rem;
        text-align: center;
        border-radius: 0 0.12rem 0 0.12rem;
      }
    }
    > .body {
      padding: 0 0.5rem 0.24rem;
      box-sizing: border-box;
      > .desc {
        padding-top: 0.3rem;
        font-size: 0.28rem;
        color: #4b638a;
      }
      .btn-area {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .van-button {
          width: 48%;
          height: 0.64rem;
          line-height: 0.6rem;
        }
      }
    }
  }
  > .footer {
    margin-top: 0.4rem;
    width: 3.98rem;
    height: 0.76rem;
    > .van-button {
      box-shadow: 0px 0.08rem 0.14rem 0 #fba07a;
    }
  }
}
</style>
